import { View, Accordion, Disclosure, DisclosureTitle, DisclosurePanel, Flex, TextField, DateField, ComboBox, DatePicker, Heading, Divider, ActionButton } from '@adobe/react-spectrum';
import { Item } from '@react-stately/collections';
import React, { useEffect, useRef, useState } from 'react';
import { ContactFormData } from '../AddNewPerson';
import LanguageDropDown from '../../../../../components/protected/data-components/LanguageDropDown';
import { DataProvider } from '../../../../../components/protected/data-components/Contexts/DataContext';
import ReferenceMarketingChanelDropDown from '../formComponents/ReferenceMarketingChanelDropDown';
import { CalendarDate,parseDate } from '@internationalized/date';
import { Check, ExclamationTriangle } from 'react-bootstrap-icons';
import UserDropDown from '../formComponents/UserDropDown';
import { useDependency } from '../../../../../contexts/DependencyProvider';
import { ListMessageActionRequest } from '../../../../../services/soap/message/requests/ListMessageActionRequest';
import { useTranslation } from 'react-i18next';
interface IBaseInfoSectionProps{
  data: ContactFormData['baseInfo'];
  onChange: (data: ContactFormData['baseInfo']) => void;
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}

export const BaseInfoSection: React.FC<IBaseInfoSectionProps> = ({ data, onChange,expandedSectionKey,setExpandedSectionKey,validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus }) => {
  const [isSectionRequired,setIsSectionRequired] = useState(false);
  const[listMessageAction,setListMessageAction] = useState<any>([]);
  const{store,messageService} = useDependency();


  const getListMessageAction = async()=>{
    const response = await messageService.listMessageAction(new ListMessageActionRequest(store.Server, store.SessionId,{
            limit:100,
            offset:0
          }));
      setListMessageAction(response?.ROW || [])
  }

  useEffect(()=>{
    getListMessageAction();
  },[])

  // const filteredRefenceCodes = (marketingChannel:string)=>{
  //     const reference = listMessageAction.filter((x:any)=>x.contactReference===marketingChannel)
  //     const code = listMessageAction.filter((x:any)=>x.code===marketingChannel)
  //     return reference || []
  // }
  

  useEffect(() => {
    if(fieldConfig?.born?.required
      ||fieldConfig?.maritalStatus?.required
      ||fieldConfig?.sex?.required
      ||fieldConfig?.preferedLanguageId?.required
      ||fieldConfig?.regNumber?.required
      ||fieldConfig?.VATNumber?.required
      ){
        setValidationStatus((prev:any) => ({ ...prev, ['baseInfoSection']: false }));
        setIsSectionRequired(true)
      } 
  }, [fieldConfig]);

  const inputRef = useRef<any>(null);
    useEffect(() => {
    if (expandedSectionKey?.has?.("baseInfoSection")) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 200); 
    }
  }, [expandedSectionKey]);

  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey:any) => prevKey.has("baseInfoSection") ? new Set() : new Set(["baseInfoSection"]));
  };
  
  const handleConfirm = ()=>{
    const errors:any = {};
    if(fieldConfig?.born?.required && data.birthDate.trim() === ''){
      errors.born = 'Dob is required';
    }
    if(fieldConfig?.maritalStatus?.required && data.maritalStatus.trim() === '0'){
      errors.maritalStatus = 'Marital status is required';
    }
    if(fieldConfig?.sex?.required && data.gender.trim() === '0'){
      errors.sex = 'Gender is required';
    }
    if(fieldConfig?.preferedLanguageId?.required && data.language.trim() === ''){
      errors.language = 'Language is required';
    }
    if(fieldConfig?.regNumber?.required && data.regNo.trim() === ''){
      errors.regNumber = 'Registration number is required';
    }
    if(fieldConfig?.VATNumber?.required && data.vatNo.trim() === ''){
      errors.VATNumber = 'VAT No is required';
    }
    if (Object.keys(errors).length > 0) {
      onChange({ ...data, language: "-1" }) 
      setValidationErrors(errors);
      setValidationStatus((prev:any) => ({ ...prev, ['baseInfoSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['baseInfoSection']: true }));
    setExpandedSectionKey(new Set(['consentSection']))
  }


  const validateRequiredFields = ()=>{
    const errors:any = {};
    if(fieldConfig?.born?.required && data.birthDate.trim() === ''){
      errors.born = 'Dob is required';
    }
    if(fieldConfig?.maritalStatus?.required && data.maritalStatus.trim() === '0'){
      errors.maritalStatus = 'Marital status is required';
    }
    if(fieldConfig?.sex?.required && data.gender.trim() === '0'){
      errors.sex = 'Gender is required';
    }
    if(fieldConfig?.preferedLanguageId?.required && data.language.trim() === ''){
      errors.language = 'Language is required';
    }
    if(fieldConfig?.regNumber?.required && data.regNo.trim() === ''){
      errors.regNumber = 'Registration number is required';
    }
    if(fieldConfig?.VATNumber?.required && data.vatNo.trim() === ''){
      errors.VATNumber = 'VAT No is required';
    }
    if (Object.keys(errors).length > 0) {
      onChange({ ...data, language: "-1" }) 
      setValidationStatus((prev:any) => ({ ...prev, ['baseInfoSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['baseInfoSection']: true }));
  }
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`addNewPerson.${key}`, { ns: 'contacts' });
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  return (
    <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
          <Disclosure id={'baseInfoSection'}>
            <DisclosureTitle>
              <Flex justifyContent="space-between" alignItems="center" width="100%">
                <View><span>{_t(`base_info`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                {validationStatus.baseInfoSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
              </Flex>
            </DisclosureTitle>
            <DisclosurePanel>
            <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
            <Flex direction="column" gap="size-100" width='100%'>
            {/* <TextField
              label="Salutation"
              value={data.salutation}
              onChange={(salutation) => onChange({ ...data, salutation })}
              width='100%' /> */}
            <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
            <DatePicker
              label={_t("birth_date")}
              ref={inputRef}
              value={data.birthDate ? parseDate(data.birthDate) : undefined}
              onChange={(date) => onChange({ ...data, birthDate: date? date.toString() : '' })}
              onBlur={()=>validateRequiredFields()}
              width='100%'
              isRequired={fieldConfig?.born?.required}
              errorMessage={fieldConfig?.born?.required && validationErrors.born}
              validationState={fieldConfig?.born?.required && validationErrors.born ? data.birthDate === '' ? 'invalid' : 'valid' : undefined} />
            <ComboBox
              label={_t("marital_status")}
              selectedKey={data.maritalStatus}
              onSelectionChange={(maritalStatus) => onChange({ ...data, maritalStatus: maritalStatus ? maritalStatus.toString() : '' })}
              onBlur={()=>validateRequiredFields()}
              width='100%'
              isRequired={fieldConfig?.maritalStatus?.required}
              errorMessage={fieldConfig?.maritalStatus?.required && validationErrors.maritalStatus}
              validationState={fieldConfig?.maritalStatus?.required && validationErrors.maritalStatus ? data.maritalStatus === '0' ? 'invalid' : 'valid' : undefined}
            >
              <Item key="0">Not specified</Item>
              <Item key="1">Single</Item>
              <Item key="2">Married</Item>
              <Item key="3">Divorced</Item>
              <Item key="4">Widow/er</Item>
            </ComboBox>
            </Flex>
            <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
            <ComboBox
              label={_t("gender")}
              selectedKey={data.gender}
              onSelectionChange={(gender) => onChange({ ...data, gender: gender ? gender.toString() : '' })}
              onBlur={()=>validateRequiredFields()}
              width='100%'
              isRequired={fieldConfig?.sex?.required}
              errorMessage={fieldConfig?.sex?.required && validationErrors.sex}
              validationState={fieldConfig?.sex?.required && validationErrors.sex ? data.gender === '0' ? 'invalid' : 'valid' : undefined}
            >
              <Item key="0">Not specified</Item>
              <Item key="1">Male</Item>
              <Item key="2">Female</Item>
            </ComboBox>
            <DataProvider>
              <LanguageDropDown 
                onValueChange={(language) => 
                onChange({ ...data, language: language ? language.toString() : "" })} 
                onBlur={validateRequiredFields}
                compKey={'123'} 
                label={'Language'} 
                value={data.language}
                isRequired={fieldConfig?.preferedLanguageId?.required}
                width='100%'/>
            </DataProvider>
            </Flex>
            <Divider size='M' UNSAFE_style={{marginTop:10}}/>
            <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
            <TextField
              label={_t("registration_number")}
              value={data.regNo}
              onChange={(regNo) => onChange({ ...data, regNo })}
              onBlur={()=>validateRequiredFields()}
              width='51%'
              isRequired={fieldConfig?.regNumber?.required}
              errorMessage={fieldConfig?.regNumber?.required && validationErrors.regNumber}
              validationState={fieldConfig?.regNumber?.required && validationErrors.regNumber ? data.regNo === '' ? 'invalid' : 'valid' : undefined} />
            <TextField
              label={_t("vat_no")}
              value={data.vatNo}
              onChange={(vatNo) => onChange({ ...data, vatNo })}
              onBlur={()=>validateRequiredFields()}
              width='25%'
              isRequired={fieldConfig?.VATNumber?.required}
              errorMessage={fieldConfig?.VATNumber?.required && validationErrors.VATNumber}
              validationState={fieldConfig?.VATNumber?.required && validationErrors.VATNumber ? data.vatNo === '' ? 'invalid' : 'valid' : undefined} />
              <ComboBox
              label={_t("category")}
              selectedKey={data.category}
              onSelectionChange={(category:any) => onChange({ ...data, category })}
              width='25%'
            >
              <Item key="">{''}</Item>
            </ComboBox>
            </Flex>
            <Divider size='M' UNSAFE_style={{marginTop:10}}/>
            <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
              <ReferenceMarketingChanelDropDown 
              selectedChanel={data.marketingChannel} 
              onChange={(channel)=>{ 
                const {refId,refName,refStandardtype} = channel; 
                onChange({...data,marketingChannel:refName,refId,refStandardtype}); 
              }
            }
            />
            <UserDropDown
              selectedUser={data.user}
              onChange={(user)=>{
                const {id,userName} = user;
                onChange({...data,user:userName});
              }}
              isHidden = {data.refStandardtype !== '2'}
             />
             <ComboBox
              label={_t("reference_code")}
              aria-label={t("reference_code")}
              items={listMessageAction}
              selectedKey={data.trackingCode}
              onSelectionChange={(value)=>{
                onChange({...data,trackingCode:value?value.toString():""})
              }}
              width= {{base:"100%",L:"50%"}}
              // isRequired={isRequired}
              isHidden={data.refStandardtype !=="3"}
          >
            {(item:any) => (
              <Item key={item.code} textValue={item.code}>
                {item.code}
              </Item>
            )}
          </ComboBox>
            </Flex>
            
          </Flex>
          <Flex direction="row" gap={'size-100'} marginTop={10} justifyContent='end'>
                    <View>
                      <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2',padding:10}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton>
                    </View>
              </Flex>
            </DisclosurePanel>
          </Disclosure>
          </Accordion>
);
}
